export default {
  contained: {
    margin: '5px 0 0',
    fontSize: 10,
  },
};
